import _ from 'lodash';
import { isApolloGraphQLError } from './errorTypeCheck';


/*
* Extract an array of error messages from a graphQL error response
*
* The 'message' field is required per the graphQL specification:
* http://facebook.github.io/graphql/October2016/#sec-Errors
 */
const getGraphQLErrorMessages = (graphQLErrors) => {
  return graphQLErrors.map((error) => {
    const { message } = error;
    return message;
  });
};


/*
* Extract an array of error details from a graphQL error response
*
* The 'details' field is not guaranteed to exist and is added to some error responses by the
* hsiapi.
*
* This array will contain either the detail string, or an empty string to indicate its absence.
 */
const getGraphQLErrorDetails = (graphQLErrors) => {
  return graphQLErrors.map((error) => {
    const { details } = error;
    if (!details) {
      return '';
    }
    return details;
  });
};


export const getGraphQLErrorAsString = (graphQLErrors, includeDetails = true, delimiter = ':') => {
  const messages = getGraphQLErrorMessages(graphQLErrors);
  if (!includeDetails) {
    return messages;
  }

  const details = getGraphQLErrorDetails(graphQLErrors);
  const messagesWithDetails = _.zip(messages, details);

  return messagesWithDetails.map(([message, detail]) => {
    if (detail === '') {
      return message;
    }

    return `${message}${delimiter} ${detail}`;
  });
};


export const tryHandleGraphQLError = (error, includeDetails = true, delimiter = ':') => {
  if (!isApolloGraphQLError(error)) {
    throw error;
  }

  return getGraphQLErrorAsString(error.graphQLErrors, includeDetails, delimiter);
};
